import { Backend } from '.';

export interface CountryMap {
  [key: string]: string;
}

const cachedCountryMaps = new Map<string, Promise<CountryMap>>();

export function getCountryMap(language: string) {
  if (cachedCountryMaps.has(language)) return cachedCountryMaps.get(language);
  const response = Backend.get<CountryMap>(`/settings/countries`);
  cachedCountryMaps.set(language, response);
  return response;
}
